export default __webpack_public_path__ + "static/media/settings.b262dc39.svg";